export default {
      id: "graph-jamesien-usage",
      viewBox: "0 0 186 186",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-jamesien",
      toString: function () {
        return this.url;
      }
    }